export const hexToRgb = (hex) => {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
};

export const generatePieData = (data, type) => {
  let pieData = {};
  pieData.labels = [];
  pieData.datasets = [
    {
      data: [],
      backgroundColor: [],
      borderColor: [],
      borderWidth: 1.5,
    },
  ];
  data.cities[type].forEach((city) => {
    pieData.labels.push(city.name);
    pieData.datasets[0].data.push(city[type]);
    const { r, g, b } = hexToRgb(city.color);
    pieData.datasets[0].backgroundColor.push(`rgba(${r}, ${g}, ${b}, 0.6)`);
    pieData.datasets[0].borderColor.push("white");
  });

  return pieData;
};
